module.exports = __webpack_public_path__ + "img/logo2.8f165859.png";